// extracted by mini-css-extract-plugin
module.exports = {"prompt":"style_prompt__1cW74","radios":"style_radios__2OMwC"};